/**
 * The search each tab was last left with — so coming back to a tab from the
 * sidebar lands where it was, as in the artifact, instead of on its defaults.
 *
 * Module memory, on purpose. The URL stays the only source of the state; this
 * only remembers which URL to go back to. A page reload forgets it, which is
 * the same as opening the tab fresh.
 */

const memory = new Map<string, unknown>();

export function rememberSearch<T>(route: string, search: T): void {
  memory.set(route, search);
}

export function lastSearch<T>(route: string, fallback: T): T {
  return (memory.get(route) as T | undefined) ?? fallback;
}

/** For tests — each starts from a tab that was never visited. */
export function forgetSearches(): void {
  memory.clear();
}
